export default "__VITE_ASSET__4Q7HJgyQ__"